import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Register() {
    const [form, setForm] = useState({
        full_name: "",
        email: "",
        mobile: "",
        password: ""
    });

    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post("http://localhost:3004/api/auth/register", form);

            toast.success("Registration successful. Please login.", {
                position: "top-right",
                autoClose: 3000
            });

            setForm({
                full_name: "",
                email: "",
                mobile: "",
                password: ""
            });

            // Redirect after short delay so toast can show
            setTimeout(() => {
                window.location.href = "/nse-login";
            }, 3500);

        } catch (err) {
            toast.error(err.response?.data?.message || "Registration failed", {
                position: "top-center",
                autoClose: 3000
            });
        }
    };

    return (
        <div
            className="container-fluid min-vh-100 d-flex justify-content-center align-items-center"
            style={{ background: "linear-gradient(135deg, #000000, #1a1a1a)" }}
        >
            <div className="col-md-4 col-sm-8">
                <div
                    className="card shadow-lg border-warning"
                    style={{ backgroundColor: "#0b0b0b" }}
                >
                    <div className="card-body p-4">
                        <h3 className="text-center text-warning mb-1">
                            Investor Registration
                        </h3>
                        <p className="text-center text-white mb-4">
                            Start investing in Mutual Funds
                        </p>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label text-warning">Full Name</label>
                                <input
                                    type="text"
                                    name="full_name"
                                    className="form-control bg-dark text-light border-secondary"
                                    placeholder="Full Name"
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label text-warning">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control bg-dark text-light border-secondary"
                                    placeholder="Email Address"
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label text-warning">Mobile Number</label>
                                <input
                                    type="text"
                                    name="mobile"
                                    className="form-control bg-dark text-light border-secondary"
                                    placeholder="Mobile Number"
                                    maxLength="10"
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3 position-relative">
                                <label className="form-label text-warning">Password</label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    className="form-control bg-dark text-light border-secondary"
                                    placeholder="Password"
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    style={{
                                        position: "absolute",
                                        top: "38px",
                                        right: "10px",
                                        cursor: "pointer",
                                        color: "#ffc107"
                                    }}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            <button className="btn btn-warning w-100 fw-bold">
                                Create Account
                            </button>
                        </form>

                        <div className="text-center mt-3">
                            <span className="text-secondary">
                                Already registered?{" "}
                                <Link to="/nse-login" className="text-warning fw-semibold">
                                    Login
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Toast Container */}
            <ToastContainer />
        </div>
    );
}

export default Register;
